<template>
  <!-- Englober par un <v-expansion-panels inset>-->
  <v-expansion-panel>
    <v-expansion-panel-header>
      <h3>
        {{label}}
      </h3>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="body-1">
      <v-treeview ref="treeview"
                  :items="computedItems"
                  item-text="lang00"
                  v-bind:value="value"
                  selectable
                  v-on:input="update"
                  return-object
                  item-disabled="readonly"
                  v-model="selection"
                  :selection-type="selectionType">
      </v-treeview>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: true,
        default: ''
      },
      items: {
        type: Array,
        required: true,
        default: () => []
      },
      value: {
        type: Array,
        required: false,
        default: () => []
      },
      index: {
        type: Number,
        default: 0
      },
      multiple: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
			selectionType: {
				type: String,
				default: 'independent'
			},
    },
    data () {
      return {
        selection: [],
        computedItems: [],
        allParentNodes: true,
      }
    },
    computed: {
      _items () {
        const replaceChildren = (obj, parent) => {
          const clone = Object.assign({}, obj)
          delete clone.children
          if (parent && parent > 0) clone.parent = parent
          return clone
        }

        const addItems = (arr, parent) => {
          const items = arr.reduce((acc, x) => {

            acc.push(replaceChildren(x, parent))

            if (x.children) {
              acc.push(addItems(x.children, x.id))
            }
            return acc
          }, [])

          return items.flat()
        }

        return addItems(this.items).reduce((acc, x) => {
          acc[x.id] = x
          return acc
        }, {})
      },
      _selection () {
        const proxy = {}
        const addParents = (x, all) => {
          const parentId = this._items[x.id].parent
          if (parentId && parentId > 0) {
            if (all) addParents(this._items[parentId])
            proxy[parentId] = this._items[parentId]
          }
        }
        this.selection.forEach(x => {
          addParents(x, this.allParentNodes)
          proxy[x.id] = x
        })
        return Object.values(proxy)
      }
    },
    mounted () {
      if (this.disabled) {
        this.computedItems = this.disableItems(this.items)
      } else {
        this.computedItems = this.items
      }
      
      this.selection = this.value
    },
    methods: {
      update (event) {
        if (this.multiple == false && event.length > 1) {
          event.splice(0, 1)
        }
        this.$emit('updateCatalogue', { value: this._selection, index: this.index })
				this.selection = this._selection
      },
      disableItems (items) {
        const acc = []
        
        items.forEach(value => {
          const clone = Object.assign({readonly: this.disabled}, value)

          if (clone.children)
          {
            clone.children = this.disableItems(clone.children)
          }

          acc.push(clone)
        })
        
        return acc
      }
    }
  }
</script> 

<style>
  .v-treeview-node__label {
    white-space: initial !important;
    max-width: 800px;
    padding-top:12px;
  }
</style>